import React from "react";

function Spacer(){
  return (
    <div
      style={{
        flexGrow: 1,
        display: "flex"
      }}
    />
  );
}

export default Spacer;